import React, { Component } from "react";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";
import moment from "moment";
import numeral from "numeral";

import Box from "../Layout/components/Box";
import ButtonStrip from "../Layout/components/ButtonStrip";
import BoxButton from "../Layout/components/BoxButton";
import ModalCreate from "./components/ModalCreate";
import DetalleParametro from "./components/DetalleParametro";

import {
  displayModalCreate,
  obtenerParametros,
  seleccionarParametro,
  eliminarParametros,
  reiniciarEstado,
  filtrarParametros,
  ordenarPor
} from "./actions";

import { showModalConfirmAction } from "../Layout/actions";

export const tableColumns = [
  {
    id: 1,
    caption: "NOMBRE",
    value: "nombre",
    type: "string",
    format: "",
    width: "30%"
  },
  {
    id: 2,
    caption: "DESCRIPCIÓN",
    value: "descripcion",
    type: "string",
    format: "",
    width: "70%"
  }
];

export function findValues(c, x) {
  let value = x.getIn(c.value.split("."));
  return value;
}

class Parametros extends Component {
  componentWillMount() {
    this.props.obtenerParametros();
  }

  componentWillUnmount() {
    this.props.reiniciarEstado();
  }

  render() {
    if (!this.props.elementos) return null;
    const { parametros, selected, termino, sortBy, asc } = this.props;

    const buttons = [];
    if (this.props.elementos.filter(x => x === "QOAGYq84").count())
      buttons.push(
        <BoxButton
          key={`action[0][0]`}
          name="plus"
          onClick={e =>
            this.props.displayModalCreate(
              true,
              "Creación de nuevo parametro",
              "create"
            )
          }
          title="Nuevo parametro"
        />
      );
    if (this.props.elementos.filter(x => x === "QOAGYq84").count())
      buttons.push(
        <BoxButton
          key={`action[0][1]`}
          name="pencil"
          onClick={e =>
            this.props.displayModalCreate(
              true,
              "Modificación de parametro",
              "edit"
            )
          }
          title="Modificar parametro"
          disabled={!!!selected}
        />
      );
    if (this.props.elementos.filter(x => x === "aj8yYfIF").count())
      buttons.push(
        <BoxButton
          key={`action[0][2]`}
          name="trash"
          onClick={e =>
            this.props.showModalConfirmAction(
              true,
              "Está seguro que desea eliminar este registro?",
              () => this.props.eliminarParametros()
            )
          }
          title="Eliminar parametro"
          disabled={!!!selected}
          danger
        />
      );

    let records = parametros
      .valueSeq()
      .toList()
      .filter(
        x =>
          x
            .get("nombre")
            .toLowerCase()
            .indexOf(termino.toLowerCase()) > -1
      )
      .sortBy(x => x.getIn(sortBy.split(".")) || "");
    if (!asc) records = records.reverse();

    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
      >
        <div className="row" style={{ height: "100%" }}>
          <div className="col-md-4" style={{ height: "100%" }}>
            <Box title="Listado de parametros" stretch>
              <ButtonStrip
                actions={buttons}
                searchBar={this.props.filtrarParametros}
                filtro={termino}
              />
              <div className="box-content" style={{ flex: 1, height: 0 }}>
                <table className="table table-condensed table-striped table-bordered table-hover nowrap">
                  <thead>
                    <tr>
                      {tableColumns.map(x => {
                        const style = { width: `${x.width}` };
                        return (
                          <th
                            key={`th1[${x.id}]`}
                            style={style}
                            onClick={() => this.props.ordenarPor(x.value)}
                          >
                            {x.caption}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {records.count() > 0 ? (
                      records.map((a, b) => {
                        return (
                          <tr
                            key={`tr2[${a.get("id")}]`}
                            className={`${
                              selected === a.get("id") ? "info" : ""
                            }`}
                            onClick={() =>
                              this.props.seleccionarParametro(a.get("id"))
                            }
                            style={{ cursor: "pointer" }}
                          >
                            {tableColumns.map((c, d) => {
                              let alignment = "left";
                              let value = findValues(c, a);
                              if (c.type) {
                                switch (c.type) {
                                  case "datetime":
                                    value = moment(value).format(c.format);
                                    alignment = "right";
                                    break;
                                  case "bool":
                                    if (typeof value === "string")
                                      value = parseInt(value, 10);
                                    value = (
                                      <div
                                        style={{
                                          textAlign: "center",
                                          fontSize: "1.1em"
                                        }}
                                      >
                                        <i
                                          className={`fa fa-${
                                            value ? "check-" : ""
                                          }square`}
                                        />
                                      </div>
                                    );
                                    break;
                                  case "number":
                                    value = numeral(value).format(c.format);
                                    alignment = "right";
                                    break;
                                  default:
                                }
                              }
                              const style = { textAlign: alignment };

                              if (c.link) {
                                return (
                                  <td
                                    key={`td1[${a.get("id")}][${c.id}]`}
                                    className="LinkToEdit"
                                    style={style}
                                    onClick={e =>
                                      this.props.displayModalCreate(
                                        true,
                                        "Modificación de areas",
                                        "edit",
                                        a.get("id")
                                      )
                                    }
                                  >
                                    {value}
                                  </td>
                                );
                              } else {
                                return (
                                  <td
                                    key={`td1[${a.get("id")}][${c.id}]`}
                                    style={style}
                                  >
                                    {value}
                                  </td>
                                );
                              }
                            })}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={tableColumns.length + 1}
                          style={{ textAlign: "center" }}
                        >
                          No existen registros
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Box>
          </div>
          <div className="col-md-8" style={{ height: "100%" }}>
            <DetalleParametro />
          </div>
        </div>
        <ModalCreate />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    parametros: state.parameters.get("parametros"),
    selected: state.parameters.get("selected"),
    termino: state.parameters.get("filtro"),
    sortBy: state.parameters.get("sortBy"),
    asc: state.parameters.get("asc"),
    elementos: state.layout.get("elementos")
  };
}

function mapDispatchToProps(dispatch) {
  return {
    obtenerParametros: () => dispatch(obtenerParametros()),
    displayModalCreate: (show, title, mode) =>
      dispatch(displayModalCreate(show, title, mode)),
    seleccionarParametro: id => dispatch(seleccionarParametro(id)),
    eliminarParametros: () => dispatch(eliminarParametros()),
    showModalConfirmAction: (show, message, action) =>
      dispatch(showModalConfirmAction(show, message, action)),
    reiniciarEstado: () => dispatch(reiniciarEstado()),
    filtrarParametros: termino => dispatch(filtrarParametros(termino)),
    ordenarPor: columna => dispatch(ordenarPor(columna))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Parametros);
